import { makeActionFactory } from './actionFactory';
import { ServerDetails } from 'types';

export type ActionType =
    'SERVERDETAILS_REQUEST'
    | 'SERVERDETAILS_SUCCESS'
    | 'SERVERDETAILS_FAILURE'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  SERVERDETAILS_REQUEST action notifies the app that we want to load server details (e.g. timezone information)
//
export interface ServerDetailsRequestAction {
    type: 'SERVERDETAILS_REQUEST';
}
export const serverDetailsRequest = actionFactory.empty<ServerDetailsRequestAction>('SERVERDETAILS_REQUEST');


//
//  SERVERDETAILS_SUCCESS action notifies the app that loaded server details
//
export interface ServerDetailsSuccessAction {
    type: 'SERVERDETAILS_SUCCESS';
    payload: ServerDetails;
}
export const serverDetailsSuccess = actionFactory.payload<ServerDetailsSuccessAction, ServerDetails>('SERVERDETAILS_SUCCESS');


//
//  SERVERDETAILS_FAILURE action notifies the app that we failed to load server details
//
export interface ServerDetailsFailureAction {
    type: 'SERVERDETAILS_FAILURE';
    payload: Error;
    error: true;
}
export const serverDetailsFailure = actionFactory.error<ServerDetailsFailureAction>('SERVERDETAILS_FAILURE');



// WEBPACK FOOTER //
// ./src/actions/serverActions.ts